





















































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import ShoppingCartItemActions from '@/components/shopping-cart/ShoppingCartItemActions.vue';
import { ShoppingCartItem } from '@/entities/ShoppingCartItem';
import ShoppingCartItemUserInfoText from '@/components/shopping-cart/ShoppingCartItemUserInfoText.vue';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import BaseMixin from '@/mixins/BaseMixin';
import { ShoppingCartModuleTypes } from '../../store/modules/shopping-cart';
import Price from '@/components/price/Price.vue';
import { localize } from '../../filters/localize';
import { PartDeliveryTimeInformation } from '../../entities/PartDeliveryTimeInformation';
import DeliveryTimeToolTip from '@/components/delivery-time-tooltip/DeliveryTimeToolTip.vue';

@Component({
    components: {
        ShoppingCartItemActions,
        ShoppingCartItemUserInfoText,
        LoadingIndicator,
        Price,
        DeliveryTimeToolTip,
    },
})
export default class ShoppingCartOverviewItem extends Mixins(BaseMixin) {
    @Prop({ required: true })
    private cartItem!: ShoppingCartItem;
    @Prop(String)
    private partDetailLink!: string;
    @Prop(Boolean)
    private isLoadingAvailability!: boolean;

    private getAvailableItemCount(item: ShoppingCartItem): number | undefined {
        if (!item.isUsedPart) {
            return undefined;
        }
        if (!item.partAvailability || !item.partAvailability.stockInfos) {
            return 0;
        }
        return item.partAvailability.stockInfos
            .map((info) => info.quantity)
            .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    }

    private saveUserInfoText(userInfoText: string): void {
        this.$store.dispatch(ShoppingCartModuleTypes.actions.updateUserInfoTextOfShoppingCartItem, {
            shoppingCartItemId: this.cartItem.id,
            userInfoText,
        });
    }

    private saveQuantity(quantity: number): void {
        this.$store.dispatch(ShoppingCartModuleTypes.actions.updateQuantityOfShoppingCartItem, {
            shoppingCartItemId: this.cartItem.id,
            quantity,
        });
    }

    private deleteItem(): void {
        this.$store.dispatch(ShoppingCartModuleTypes.actions.deleteItemFromActiveShoppingCart, {
            shoppingCartItemId: this.cartItem.id,
        });
    }

    private moveItem(targetShoppingCartId: number): void {
        this.$store.dispatch(ShoppingCartModuleTypes.actions.moveItemToShoppingCart, {
            shoppingCartItemId: this.cartItem.id,
            targetShoppingCartId,
        });
    }

    private partDetailLinkForCartItem(): string {
        return `${this.partDetailLink}${encodeURIComponent(this.cartItem.fullPartId)}`;
    }
}
